import React from "react";

export const textFormatter = (cell) => {
  return (
    <div className="flex flex-col">
      {cell.map((text, index) => (
        <p key={index} title={text}>
          {text}
        </p>
      ))}
    </div>
  );
};
